import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { SeoService } from '../@service/seo.service';
import { AppService } from '../@service/app.service';

@Injectable({
    providedIn: 'root'
})
export class TeamResolver implements Resolve<any> {
    constructor(
        private _appService: AppService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this._appService.getTeam();
    }
}
